import styled, { css } from 'react-emotion';
import arrows from './arrows.png';
import arrowRight from './arrowRight.png';
import React from 'react';
import { ThemeProvider } from 'emotion-theming';

export const LightButton = (props) => {
	const theme = {
		buttonText: '#00467f',
		buttonBg: '#f7f7f7'
	}

	return (
		<ThemeProvider theme={theme}>
			<Button {...props} />
		</ThemeProvider>
	)
}

export const Button = styled.button`
	background: ${props => props.theme.buttonBg};
	border: 1px solid #d9d9d9;
	border-radius: 2px;
	color: ${props => props.theme.buttonText};
	display: block;
	font-size: 0.75rem;
	line-height: 3;
	margin: 0 auto 2rem;
	padding: 0 2rem 0 1rem;
	text-transform: uppercase;
	transition: 0.1s;

	&:hover {
		background: #ccc;
		border-color: #b3b3b3;
		color: #1a1a1a;
		cursor: pointer;
	}
`;

Button.defaultProps = {
	theme: {
		buttonText: '#595959',
		buttonBg: '#f7f7f7'
	}
}


export const Text = styled.span`
	position: relative;

	&:after {
		background: center bottom no-repeat url('${arrows}');
		content: "";
		display: block;
		height: 11px;
		position: absolute;
		right: -22px;
		top: 2px;
		width: 11px;
	}
`;

export const open = css`
	&:after {
		background-position: center top;
	}
`;

export const ArrowRight = styled.span`
	position: relative;

	&:after {
		background: center bottom no-repeat url('${arrowRight}');
		content: "";
		display: block;
		height: 11px;
		position: absolute;
		right: -22px;
		top: 2px;
		width: 11px;
	}
`;
